module.exports = __webpack_public_path__ + "img/email2-icon.86b0dc39.png";